import { ComponentProps, FC } from 'react';
import logoIcon from '@assets/logo-icon.webp';
import { cn } from '@new/lib';
import { Loader2Icon } from 'lucide-react';

interface LoaderProps {
  showLogo?: boolean;
}

const Spinner: FC<ComponentProps<'svg'>> = ({ className, ...props }) => {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
};

export const Loader: FC<LoaderProps> = ({ showLogo = true }) => (
  <div className="flex flex-col items-center justify-center w-full h-full">
    {showLogo && (
      <img
        src={logoIcon}
        alt="Newlane university"
        style={{ maxHeight: 60, marginBottom: 12, display: 'inline-block' }}
      />
    )}
    <Spinner />
  </div>
);
